// extracted by mini-css-extract-plugin
module.exports = {"loadingPanel":"loading-panel-module--loadingPanel--10fa7","title":"loading-panel-module--title--1By89"};